import React, { FC } from 'react';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './showcaseStyles.scss';

const Showcase: FC<{ showcaseItems: { [key: string]: string[] } }> = ({ showcaseItems }) => (
  <div className={styles.showcase}>
    {Object.entries(showcaseItems).map(([title, items]) => (
      <div className={styles.showcaseItem} key={`showcase-item-${title}`}>
        <h4>{title}</h4>
        {items.map((item, index) => (
          <div className={styles.showcaseCheckItem} key={`showcase-check-item-${index}`}>
            <p>
              <FontAwesomeIcon icon={faCircleCheck} />
            </p>
            <p>{item}</p>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default Showcase;
